import { councilAlarmApi } from "@/lib/api"
import type { ApiResponseLeakCountDTO, LeakCountDTO } from "@/gen/api"
import { useQuery } from "@tanstack/react-query"

const useGetAllTimeLeakCount = (councilId: string) => {
  return useQuery({
    queryKey: [useGetAllTimeLeakCount.QUERY_KEY, councilId],
    queryFn: async () => {
      const response = await councilAlarmApi.getAllTimeLeakCount(councilId)
      return (response.data as ApiResponseLeakCountDTO).data as LeakCountDTO
    },
    enabled: !!councilId,
  })
}

useGetAllTimeLeakCount.QUERY_KEY = "all-time-leak-count"

export default useGetAllTimeLeakCount
